import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IACSForm from '../../../form/PensosbudForm/Darmawisata/IACSAlumni';

import { getSosBudServiceId } from '../../../form/PensosbudForm/functions';

const Schollarship = ({ i18n, sosBudServiceList }) => {
  const lang = (type, params) => i18n(`pensosbud.tab10.${type}`, { ...params });
  const serviceId = getSosBudServiceId(sosBudServiceList, 'alumniBSBI');

  return (
    <div className='card-instruction-detail'>
      <div className='title'>{lang('title')}</div>
      <main>
        <div className='instruction-wrap'>
          <div dangerouslySetInnerHTML={{ __html: lang('step.instruction') }} />
        </div>
        <IACSForm i18n={i18n} serviceId={serviceId} />
      </main>
    </div>
  );
};

Schollarship.propTypes = {
  i18n: PropTypes.func,
  sosBudServiceList: PropTypes.array
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Schollarship);
